import React, { useState } from "react";
import Close from "../assets/svg/close.svg";
import { connect } from "react-redux";

import { motion } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addProgress } from "../store/actions/authActions";

function Addprogress(props) {
  const { off, addProgress, auth } = props;
  const [goal_date, setgoal_date] = useState(new Date());
  const [goal_weight, setgoal_weight] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    addProgress({ goal_date, goal_weight, id: auth.uid });
    off(false);
  };

  return (
    <motion.div
      style={{
        background: "#EE1D52",
        padding: "10px",
        position: "absolute",
        zIndex: 9999999,
        width: "80%",
        left: 0,
        right: 0,
        top: "100px",
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: "7px",
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", duration: 1.4 }}
    >
      <div
        onClick={(e) => off(false)}
        style={{ position: "absolute", right: "15px", top: "15px" }}
      >
        <img src={Close} alt="close" style={{ maxHeight: "20px" }}></img>
      </div>

      <div className="yalla">
        <h3 style={{ textAlign: "center" }}>Ajouter Progrès</h3>
        <div style={{ height: "10px" }}></div>
        <form onSubmit={handleSubmit}>
          <div>
            <DatePicker
              selected={goal_date}
              onChange={(date) => setgoal_date(date)}
              id="goal_date"
            />
          </div>
          <div style={{ height: "20px" }}></div>
          <div style={{ padding: "10px" }}>
            <input
              style={{
                height: "50px",
                padding: "5px",
                width: "100%",
                border: "0",
                borderRadius: "4px",
                fontSize: "18px",
              }}
              type="numéro"
              required
              placeholder="Entrez votre poids"
              id="objectif_poids"
              defaultValue={goal_weight}
              onChange={(event) => setgoal_weight(event.target.value)}
            />
          </div>

          <p style={{ fontSize: "16px", textAlign: "center", padding: "10px" }}>
            <button
              style={{
                fontSize: "18px",
                background: "#333",
                padding: "10px",
                border: 0,
                borderRadius: "4px",
                fontWeight: "600",
                width: "100%",
                color: "white",
              }}
            >
              Add Progress
            </button>
          </p>
        </form>
      </div>
    </motion.div>
  );
}

function mapStateToProps(state) {
  return { auth: state.firebase.auth };
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProgress: (obj) => dispatch(addProgress(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Addprogress);
